<template>
    <section class="popup-bodega" :show="show">
        <a class="close" @click="setShowed">✕</a>
        <router-link :to="$t(`enlaces.vino`)+$t(`enlaces.premios`)+'#navamarin-bruselas-2022'" class="enlace-cover" @click.native="setShowed">
        </router-link>
        <img width="250" src="/static/img/imagen-popup.png" alt="Ven a visitar nuestra bodega y almazara. ¡Haz tu reserva aquí!">
    </section>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        name: 'popup-bodega',
        mounted() {

            $(document).scroll(() => {
                if ($(document).scrollTop() >= 968) {
                    if (!window.sessionStorage.getItem('popup')) {
                        this.show = true;
                    }
                }
            });
        },
        data: () => ({
            show: false
        }),
        methods: {
            setShowed() {
                window.sessionStorage.setItem('popup', true);
                this.show = false;
            }
        },
        computed: {
            ...mapGetters({
                lang: 'getLanguage',
            })
        }
    }
</script>


<style lang="scss" scoped>
    .popup-bodega {
        position: fixed;
        right: 20px;
        bottom: 20px;
        z-index: 15;
        transform: translateY(120%);
        transition: .7s;
        transition-timing-function: ease-in-out;

        &[show=true] {
            transform: translateY(0%);
        }

        .enlace-cover {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 8;
        }

        .close {
            position: absolute;
            right: 0px;
            top: 0px;
            z-index: 10;
            width: 40px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
        }
    }

    @media screen and (max-width:600px){

        .popup-bodega{
            bottom: 10px;
            right: 10px;
        }

        .popup-bodega img{
            max-width: 160px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-bodega.vue